import React, { memo } from 'react';
import { DatePicker } from 'antd';

const DATE_FORMAT = 'MM/DD/YY';

function DotDescriptionEditor({
  changeTreeDataCollection,
  startAt,
  dateRange = [],
  order,
  setPhaseDates,
  formChange = () => {},
}) {
  const handleChange = (e) => {
    formChange();
    setPhaseDates((currentDates) => {
      const result = [...currentDates];
      result[order] = e;

      result.forEach((moment, index) => {
        changeTreeDataCollection({
          location: [index],
          payload: { startAt: moment?.toDate ? moment.toDate() : moment },
        });
      });

      return result;
    });
  };

  const disabledDate = (current) => {
    if (dateRange[0] && dateRange[1]) {
      return (current && current <= dateRange[0]) || current >= dateRange[1];
    } else if (dateRange[0]) {
      return current && current <= dateRange[0];
    } else if (dateRange[1]) {
      return current && current >= dateRange[1];
    }

    return false;
  };

  return (
    <div className="date-selector-wrapper">
      <DatePicker
        defaultPickerValue={DatePicker[0] || DatePicker[1] || null}
        disabledDate={disabledDate}
        defaultValue={startAt}
        onChange={handleChange}
        format={DATE_FORMAT}
        placeholder=""
        size="small"
        autoFocus={false}
        suffixIcon={<span className="appkiticon icon-calendar-fill" />}
        getPopupContainer={() =>
          document.getElementsByClassName('lifecycle-phases-container')[0] ||
          document.body
        }
      />
    </div>
  );
}

DotDescriptionEditor.propTypes = {};

export default memo(DotDescriptionEditor);
